import { render, staticRenderFns } from "./TodoListGroupTitle.vue?vue&type=template&id=44a21468&scoped=true&"
import script from "./TodoListGroupTitle.vue?vue&type=script&lang=ts&"
export * from "./TodoListGroupTitle.vue?vue&type=script&lang=ts&"
import style0 from "./TodoListGroupTitle.vue?vue&type=style&index=0&id=44a21468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a21468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
